import axios, { AxiosResponse } from 'axios';
import { AppConfig } from '@/app.config';
import { IResponseData } from '@/interfaces/response.interface';
import { IRequestProfileGet } from '@/modules/Profile/interfaces/request-profile-get.interface';
import { IRequestProfileSet } from '@/modules/Profile/interfaces/request-profile-set.interface';
import {IProfile} from '@/modules/Profile/interfaces/profile.interface';

class ProfileResource {
  get (token: string, orderId: string): Promise<AxiosResponse<IResponseData<IProfile.ResourceGetResponseDataResult>>> {
    return (axios.post(AppConfig.apiUrl, {
      action: IRequestProfileGet.ACTION,
      params: IRequestProfileGet.convertToInputParams(IRequestProfileGet.Commands.CONTACTS, orderId),
      token: token,
      version: 1.0
    }) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      response.data['result'] = IRequestProfileGet.convertToOutputResult(response.data.result);
      return response;
    });
  }

  changePassword ( token: string, email: string, oldPassword: string, newPassword: string, ): Promise<AxiosResponse<IResponseData<IProfile.ResourceChangePasswordResponseDataResult>>> {
    return (axios.post(AppConfig.apiUrl, {
      action: IRequestProfileSet.ACTION,
      params: IRequestProfileSet.convertToInputChangePasswordParams(IRequestProfileSet.Commands.PASSWORD, email, oldPassword, newPassword),
      token: token,
      version: 1.0
    }) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      response.data['result'] = IRequestProfileSet.convertToOutputResult(response.data.result);
      return response;
    });
  }

  changeEmail ( token: string, email: string, password: string, ): Promise<AxiosResponse<IResponseData<IProfile.DataProfile>>> {
    return (axios.post(AppConfig.apiUrl, {
      action: IRequestProfileSet.ACTION,
      params: IRequestProfileSet.convertToInputChangeEmailParams(IRequestProfileSet.Commands.EMAIL, email, password),
      token: token,
      version: 1.0
    }) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      response.data['result'] = IRequestProfileSet.convertToOutputResult(response.data.result);
      return response;
    });
  }

  confirmEmail ( token: string, confirmGUID: string ): Promise<AxiosResponse<IResponseData<IProfile.DataProfile>>> {
    return (axios.post(AppConfig.apiUrl, {
      action: IRequestProfileSet.ACTION,
      params: IRequestProfileSet.convertToInputConfirmEmailParams(IRequestProfileSet.Commands.CONFIRM_EMAIL, confirmGUID ),
      token: token,
      version: 1.0
    }) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      response.data['result'] = IRequestProfileSet.convertToOutputConfirmEmailResult(response.data.result);
      return response;
    });
  }
}

export const profileResource = new ProfileResource();
